export default __webpack_public_path__ + "static/media/home-artboard-3.170b9282.jpg";